import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserApplicationForm } from '../../../models/forms/user-form';
import { Application } from '../../../models/application';
import { Role } from '../../../models/role';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-user-app-entry',
    templateUrl: './user-app-entry.component.html',
    styleUrls: ['./user-app-entry.component.sass'],
    standalone: false
})
export class UserAppEntryComponent implements OnInit, OnDestroy {
  @Input({ required: true }) inputId!: number;
  @Input({ required: true }) appForm!: FormGroup<UserApplicationForm>;
  @Input({ required: true }) availableApplications!: Application[];
  @Input() selectedApplications: string[] = [];

  @Output() appRemoved: EventEmitter<void> = new EventEmitter();

  get appId(): string {
    return this.appForm.controls.applicationId.value;
  }

  protected isAvailable: boolean = false;
  protected availableRoles: Role[] = [];
  protected appIdentifier: string = '';

  private applicationSubscription: Subscription = new Subscription();

  ngOnInit(): void {
    this.isAvailable =
      (!this.appForm.controls.applicationId.dirty &&
        !this.appForm.controls.applicationId.getRawValue()) ||
      this.availableApplications.findIndex(
        (a) => a.id === this.appForm.controls.applicationId.getRawValue()
      ) >= 0;

    if (!this.isAvailable) {
      this.appForm.disable();
    }

    this.getRolesForApp(this.appId);

    this.applicationSubscription = this.appForm.controls.applicationId.valueChanges.subscribe(appId=> {
      this.appForm.controls.roles.setValue([]);
      this.getRolesForApp(appId);
      this.selectAllRoles();
    })
  }

  ngOnDestroy(): void {
    this.applicationSubscription.unsubscribe();
  }

  getRolesForApp(appId: string): void {
    this.appIdentifier = this.availableApplications.find((a) => a.id == appId)?.identifier ?? '';
    const appRoles =
      this.appId == null
        ? []
        : this.availableApplications.find((a) => a.id == this.appId)?.roles ??
        [];

    let selectedRoleNames = this.appForm.controls.roles.value;
    const selectedRoles = selectedRoleNames
      .filter((r) => appRoles.findIndex((ar) => ar.name == r) < 0)
      .map((r) => ({
        name: r,
        disabled: true,
        permissions: [],
        description: '',
      }));

    this.availableRoles = [...appRoles, ...selectedRoles];
  }

  onCheckboxSelected(event: any, roleName: string): void {
    let currentRoles = this.appForm.controls.roles.value ?? [];

    if (event.target.checked) {
      currentRoles.push(roleName);
    } else {
      let roleIdx = currentRoles.findIndex((r) => r == roleName);
      currentRoles.splice(roleIdx, 1);
    }

    this.appForm.controls.roles.setValue(currentRoles);
  }

  checkIfSelected(roleName: string): boolean {
    let currentRoles = this.appForm.controls.roles.value ?? [];
    return currentRoles.findIndex((r) => r == roleName) >= 0;
  }

  removeApplicationEntry(): void {
    this.appRemoved.emit();
  }

  selectAllRoles(): void {
    this.appForm.controls.roles.setValue(this.availableRoles.map(r => r.name));
  }

  // if the app has already been selected it is disabled in the dropdown
  // so that it cannot be selected twice
  checkIfDisabled(application: Application): boolean {
    return this.selectedApplications.some(a => a == application.id);
  }

}
